"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstCreatedFieldLogic = void 0;
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
const base_created_updated_fieldtype_1 = require("../base-fields/base-created-updated.fieldtype");
class FirstCreatedFieldLogic extends base_created_updated_fieldtype_1.BaseCreatedUpdatedFieldType {
    constructor() {
        super(...arguments);
        this.name = "firstcreatedfield";
        this.label = (0, intl_1.$t)(texts_1.createUpdateFieldText.first_created);
        this.icon = "first-created";
        this.iconColor = "#FFB938";
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.createUpdateFieldText.author),
            (0, intl_1.$t)(texts_1.createUpdateFieldText.by),
        ];
    }
}
exports.FirstCreatedFieldLogic = FirstCreatedFieldLogic;
